import React, { useEffect } from 'react';
import { redirectToSignInURL } from '../../../modules/navigation/Navigation.utils';

export const UnauthorizedRedirect: React.FC = () => {
  useEffect(() => redirectToSignInURL(), []);
  return null;
};
